module.exports = {
  "login": {
    "telLogin": "手机登录",
    "accountLogin": "账号登录",
    "accountHint": "请输入账号",
    "passwordHint": "密码",
    "passwordToastHint": "请输入密码",
    "login": "登录",
    "forgetPassword": "忘记密码？",
    "telHint": "请输入手机号",
    "code": "验证码",
    "codeHint": "请输入验证码",
    "telCode": "手机验证码",
    "telCodeHint": "请输入手机验证码",
    "sendCode": "发送验证码"
  },
};


// WEBPACK FOOTER //
// ./src/i18n/login/zh-CN.js